module.exports = __webpack_public_path__ + "h5/img/form_bg.76853230.png";